import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  IonList,
  IonItem,
  IonLabel,
  IonActionSheet,
  IonText,
  IonIcon,
  IonLoading,
} from '@ionic/react';
import {
  add,
  checkmarkOutline,
  closeOutline,
  trashOutline,
} from 'ionicons/icons';
import PayActions, { PaySelectors } from 'redux/PayRedux';
import { MethodItem } from 'components/methods';

function PaymentMethodList() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [active, setActive] = useState(null);

  const items = useSelector(PaySelectors.selectPaymentMethods);
  const currentMethod = useSelector(PaySelectors.selectCurrentMethod);
  const deleting = useSelector(PaySelectors.selectDeleting);
  
  const handleSelect = (item) => {
    dispatch(PayActions.setDefaultPaymentMethod(item._id));
  };

  return (
    <IonList>
      <IonLoading isOpen={deleting} message="Removing method..." />

      {items.map((item) => (
        <MethodItem
          key={item._id}
          item={item}
          className={currentMethod === item._id && 'selected'}
          onClick={() => setActive(item)}
        />
      ))}

      <IonItem button onClick={() => history.push('/payment-methods/add')}>
        <IonIcon slot="start" icon={add} />
        <IonLabel>
          <IonText color="primary">Add Card</IonText>
        </IonLabel>
      </IonItem>

      <IonActionSheet
        header="Actions"
        isOpen={!!active}
        onDidDismiss={() => setActive(null)}
        buttons={[
          {
            text: 'Set As Default',
            icon: checkmarkOutline,
            handler: () => {
              handleSelect(active);
            },
          },
          {
            text: 'Remove Card',
            icon: trashOutline,
            role: 'destructive',
            handler: () => {
              dispatch(PayActions.deleteCard(active._id));
            },
          },
          {
            text: 'Cancel',
            icon: closeOutline,
            role: 'cancel',
          },
        ]}
      />
    </IonList>
  );
}

export default PaymentMethodList;
